export default __webpack_public_path__ + "static/media/Icons_History_Grey Icon.f82f916c.svg";